import styled from "styled-components"
import IconButton from "@irati/ui/src/Button/IconButton"

export const StyledIconButton = styled(IconButton)`
  display: flex;
  padding: 6px;
  border-radius: 24px;
  background-color: ${({theme}) => theme.colors.greys.white};
`
